import Commons from '../../../Services/Common/Common';

export const M_NOT_BASIC_03_Schema = {
  mapper: {
    search1: {
      Chaebun: (context) => Commons.EncryptAES(context.ChaebunNo),
    },
    search2: {
      Chaebun: (context) => Commons.EncryptAES(context.ChaebunNo),
    },
    search3: {
      CoCd: (context) => Commons.EncryptAES(context.userInfo?.coCd),
      SearchText: () => Commons.EncryptAES(''),
    },
    /** 안전보건경영방침 상세 */
    search4: {
      CoCd: (context) => Commons.EncryptAES(context.userInfo?.coCd),
    },
    /** 비상대응메뉴얼 목록 */
    search5: {
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd),
    },
    /** 비상대응메뉴얼 상세 */
    search6: {
      Chaebun: (context) => Commons.EncryptAES(context.ChaebunNo),
    },
  },
};
